var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal-split', {
    scopedSlots: _vm._u([{
      key: "list",
      fn: function fn() {
        return [_vm.isPartnerFallbackLoading ? _c('v-skeleton-loader', {
          attrs: {
            "type": "list-item-two-line"
          }
        }) : _c('partner-report-list-paginated', {
          attrs: {
            "isLoadingDetail": _vm.loading
          },
          on: {
            "set": _vm.set
          }
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function fn() {
        return [_vm.loading ? _c('v-skeleton-loader', {
          attrs: {
            "type": "article, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line"
          }
        }) : !_vm.report.id ? _c('v-card', {
          staticClass: "fill-height",
          attrs: {
            "fluid": "",
            "flat": ""
          }
        }, [_c('v-layout', {
          attrs: {
            "justify-center": "",
            "align-center": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "shrink": ""
          }
        }, [_c('v-row', {
          staticClass: "pt-8"
        }, [_c('v-col', [_c('object', {
          attrs: {
            "data": _vm.svg,
            "type": "image/svg+xml",
            "height": "350px"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.svg,
            "alt": "Chat with AI illustration",
            "height": "350px"
          }
        })])])], 1), _c('v-row', {
          staticClass: "pt-8",
          attrs: {
            "align-center": ""
          }
        }, [_c('v-col', {
          staticClass: "text-center"
        }, [_vm.canCreateReport && _vm.isBroker ? _c('v-btn', {
          attrs: {
            "elevation": "0",
            "color": "info"
          },
          on: {
            "click": function click($event) {
              return _vm.$refs.partnerReportDialog.open();
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportDetail.newReport")) + " ")], 1) : _c('partner-report-initialize-dialog', {
          attrs: {
            "icon": false
          }
        }), _c('partner-report-dialog', {
          ref: "partnerReportDialog"
        })], 1)], 1)], 1)], 1)], 1) : !_vm.isReportV2 ? _c('partner-report-detail', {
          key: 'report' + _vm.report.id,
          attrs: {
            "showBreadcrumbs": false
          },
          on: {
            "setReport": _vm.loadDetail
          }
        }) : _vm.isReportV2 ? _c('partner-report-detail-v2', {
          key: 'report-v2' + _vm.report.id,
          ref: "reportDetail",
          attrs: {
            "showBreadcrumbs": false,
            "showDetailButton": true
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }